import { Spin } from "antd";

const Loading = ({ size = "large" }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin size={size} />
    </div>
  );
};

export default Loading;
